import { combineEpics } from 'redux-observable';

import authEpics from '../auth/_store/epics';
import examinationEpics from '../examination/_store/epics';

const rootEpic = combineEpics(...authEpics, ...examinationEpics);

export default rootEpic;
